import { useEffect, useState } from "react";
import { Link, Outlet,NavLink, useLoaderData, Form } from "react-router-dom"
import { Button } from "../components/Button";
import { TextField } from "../components/TextField";
import { Select } from "../components/Select";
import { change_buddy_status, reset_password } from "../services/api";
import mixpanel from "../services/mixpanel";
import { getUserId } from "../services/helpers";






export function BuddyDetails(){
	const loaderData = useLoaderData();
	const buddyData = loaderData.details.details;
	const [showPasswordDialog,setShowPasswordDialog] = useState(false);
	const [showStatusDialog,setShowStatusDialog] = useState(false);
	const [password,setPassword] = useState("");
	const [confirmPassword,setconfirmPassword] = useState("");
	const [accountStatus,setAccountStatus] = useState(buddyData.status);


async function changePassword(){
	const response = await reset_password({
		"new_password" : password,
		"user_id" : buddyData.buddy_id,
		"current_password" : "dk"
	});


	const result = await response.json();

	alert(result.message);
	setShowPasswordDialog(false);

}

async function changeStatus(){
	const response = await change_buddy_status(buddyData.buddy_id,accountStatus);
	const result = await response.json();
	alert(result.msg);
	setShowStatusDialog(false);

}

	useEffect(()=>{
		mixpanel.identify(getUserId());
	},[])


	return (
		<main id="MemberDetails">
		<h1>Buddy Details</h1>
		<Link to="/dashboard/buddies">Back to All Buddies</Link>
		<div id="page-detail-card">
			<div id="header-section">
				<div id="header-image">
					<img src="https://avatar.iran.liara.run/public/43" alt="" />
				</div>
				<div id="middle">
					<h3>{buddyData.buddy_name}</h3>
					<p>Role: {buddyData.role}</p>
					<Link onClick={()=>setShowPasswordDialog(true)}>Change Password</Link>
				</div>
				<div id="end">
					<p>Date Created: <span>{buddyData.date_created}</span></p>
					<p>Account Status: {buddyData.status} <Link onClick={setShowStatusDialog}>change status</Link></p>

				</div>
			</div>
			<div id="action-row">
				<NavLink end className={({ isActive }) => isActive ? "active-subnav" : ""} to="">Details</NavLink>
				<NavLink className={({ isActive }) => isActive ? "active-subnav" : ""} to="members">Assigned Members</NavLink>
			</div>
			<div id="body-section">
				<Outlet context={buddyData} />
			</div>

		</div>

			{showPasswordDialog && (
				<div className="dialog-overlay">

					<div className="dialog" >
						<Form id="changeBuddyPassword">
							<div className="dialog-header">
								<h3>Change Buddy Password</h3>
							</div>
							<div className="dialog-content">
								<div className="col-6">
									<TextField
										label={"New Password"}
										type={"password"}
										onChange={(e)=>setPassword(e.target.value)}
										value={password}
									/>
								</div>
								<div className="col-6">

									<TextField
										label={"Confirm Password"}
										type={"password"}
										onChange={(e)=>setconfirmPassword(e.target.value)}
										value={confirmPassword}
									/>
								</div>
								<p className="red-text">{confirmPassword === password ? "" : "Passwords do not match"}</p>
							</div>
							<div className="dialog-footer">
								<Button onClick={()=> setShowPasswordDialog(false)} color="red" label="Cancel"/>
								<Button disabled={confirmPassword !== password} onClick={changePassword} label="Change Password" color="green" type="button" />
							</div>
						</Form>
					</div>
				</div>
			)}

			{showStatusDialog && (
				<div className="dialog-overlay">

					<div className="dialog" >
						<Form id="changeAccountSatus">
							<div className="dialog-header">
								<h3>Change Account Status</h3>
							</div>
							<div className="dialog-content">
								<div className="col-6">
									<Select
										label="Type of Note"
										options={["active","inactive"]}
										name="tag"
										defaultValue={buddyData.status}
										onChange={(e) => setAccountStatus(e.target.value)}
									/>
								</div>
							</div>
							<div className="dialog-footer">
								<Button onClick={()=> setShowStatusDialog(false)} color="red" label="Cancel"/>
								<Button onClick={changeStatus} label="Change Status" color="green" type="button" />
							</div>
						</Form>
					</div>
				</div>
			)}
		</main>


	)
}